// extracted by mini-css-extract-plugin
module.exports = {"chip":"call-dialogue_chip___qJSb","content":"call-dialogue_content__1vPAO","number":"call-dialogue_number__gyz5C"};